'use strict';

module.exports = {
  Promish: null
};
